import { parseHtml } from "@/utils/common";

const ParseHtml: React.FC<{ htmlString: string }> = ({ htmlString }) => {
  return parseHtml(htmlString);
};

export default ParseHtml;
